import { getTheme } from '../queries/theme';
import { useGenericQuery } from '../../../core/api/reactQuery';
import { useEssayStore } from '../stores/essayStore';

export function useEssayTheme(slug: string) {
  const { setTheme } = useEssayStore();
  
  const { 
    data, 
    isError, 
    error, 
    isSuccess, 
    isPending 
  } = useGenericQuery(['theme', slug], () => getTheme(slug), setTheme);

  return {
    data,
    isError,
    isPending,
    error,
    isSuccess,
  }
}
